(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  /**
   * Loads the Track123 order lookup (the app's /apps/track123 page) into this card, so customers can
   * track with just their order number + email without leaving the branded page. Track123's own
   * settings (from its dashboard) come along with it. If it can't load, a link to the app page shows.
   */
  class Track123Embed extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.mount = this.querySelector('[data-t123-mount]');
      this.fallback = this.querySelector('[data-t123-fallback]');
      this.load().catch(() => this.showFallback());
      // No "Powered by Track123" label: remove it whenever Track123 renders (or re-renders) it
      const dropBranding = () => this.querySelectorAll('#track123-powered-by').forEach((el) => el.remove());
      this.brandingObserver = new MutationObserver(dropBranding);
      this.brandingObserver.observe(this, { childList: true, subtree: true });
      this.timer = setTimeout(() => {
        if (!this.querySelector('#track123-app input')) this.showFallback();
      }, 12000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.brandingObserver?.disconnect();
    }

    showFallback() {
      if (this.querySelector('#track123-app input')) return;
      this.mount.hidden = true;
      this.fallback.hidden = false;
    }

    async load() {
      const response = await fetch(this.dataset.src, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Track123 page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const app = doc.getElementById('track123-app');
      if (!app) throw new Error('Track123 app not found');

      doc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
        if (!/track123/i.test(link.href) || document.querySelector(`link[href="${link.href}"]`)) return;
        const tag = document.createElement('link');
        tag.rel = 'stylesheet';
        tag.href = link.href;
        document.head.appendChild(tag);
      });

      doc.querySelectorAll('style').forEach((style) => {
        if (!/track123/i.test(style.textContent)) return;
        const tag = document.createElement('style');
        tag.textContent = style.textContent;
        document.head.appendChild(tag);
      });

      const container = document.createElement('div');
      container.id = 'track123-app';
      container.innerHTML = app.innerHTML;
      this.mount.replaceChildren(container);

      // Settings first (window.trackingPageConfig, TRACK_BASE_URL, ...), then the app itself
      doc.querySelectorAll('script:not([src])').forEach((script) => {
        if (!/TRACK_BASE_URL|trackingPageConfig|track123/i.test(script.textContent)) return;
        const tag = document.createElement('script');
        tag.textContent = script.textContent;
        document.body.appendChild(tag);
      });

      doc.querySelectorAll('script[src]').forEach((script) => {
        if (!/track123/i.test(script.src)) return;
        const tag = document.createElement('script');
        tag.src = script.src;
        if (script.type) tag.type = script.type;
        tag.onerror = () => this.showFallback();
        document.body.appendChild(tag);
      });
    }
  }

  if (!customElements.get('track123-embed')) customElements.define('track123-embed', Track123Embed);

  } catch(e) { console.error(e); }
})();
})();
